import React from 'react'

export function UserBlack() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M9 2.063a2.438 2.438 0 100 4.875 2.438 2.438 0 000-4.875zM5.437 4.5a3.563 3.563 0 117.126 0 3.563 3.563 0 01-7.126 0zM1.688 16.5a7.312 7.312 0 1114.624 0 .562.562 0 11-1.125 0 6.187 6.187 0 10-12.374 0 .562.562 0 11-1.126 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}
